import { Component } from '@angular/core';
import { select } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TextPipe, HtmlPipe } from '@ps20-frontend/text-service';
import {
  selectErrorPageParams,
  selectErrorPageTextIds,
  selectErrorPageZusatTexte,
} from '../../store/selectors/transientState.selector';
import { selectCorrelationId } from '../../store/selectors/saveProtocol.selector';

@Component({
  selector: 'ps20-shop-errorpage',
  templateUrl: './errorpage.component.html',
  imports: [AsyncPipe, TextPipe, HtmlPipe],
})
export class ErrorpageComponent {
  @select(selectErrorPageTextIds) errorpageTextIds$: Observable<string | string[]>;
  @select(selectErrorPageZusatTexte) errorPageZusatzTexte$: Observable<string | string[]>;
  @select(selectErrorPageParams) errorPageParams$: Observable<{ [key: string]: string }>;
  @select(selectCorrelationId) correlationId: Observable<string>;

  isArray(textIds: string | string[]): boolean {
    return Array.isArray(textIds);
  }
}
